import { configureSharedCookieAuth } from "@assetwatch/auth";
import * as Sentry from "@sentry/react";
import { RouterProvider } from "@tanstack/react-router";
import { Amplify } from "aws-amplify";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./styles.css";
import { AppErrorFallback } from "./components/AppErrorFallback";
import config from "./config";
import { initFieldopsSentry } from "./lib/sentry";
import { router } from "./router";

initFieldopsSentry();

const authApiBaseUrl =
  (import.meta.env.VITE_AUTH_API_BASE_URL as string | undefined)?.replace(
    /\/$/,
    "",
  ) ?? "";

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: config.cognito.USER_POOL_ID,
      identityPoolId: config.cognito.IDENTITY_POOL_ID,
      userPoolClientId: config.cognito.APP_CLIENT_ID,
      loginWith: {
        email: true,
        oauth: {
          domain: config.cognito.DOMAIN,
          scopes: [
            "email",
            "openid",
            "aws.cognito.signin.user.admin",
            "profile",
          ],
          redirectSignIn: [`${window.location.origin}/`],
          redirectSignOut: [`${window.location.origin}/`],
          responseType: "code",
        },
      },
    },
  },
  ...(authApiBaseUrl
    ? {
        API: {
          REST: {
            apiVeroUser: {
              endpoint: `${authApiBaseUrl}/user`,
              region: "us-east-2",
            },
          },
        },
      }
    : {}),
});

configureSharedCookieAuth(import.meta.env.VITE_DEPLOY_ENVIRONMENT);

const rootElement = document.getElementById("root");

if (!rootElement) {
  throw new Error("Root element not found");
}

createRoot(rootElement).render(
  <StrictMode>
    <Sentry.ErrorBoundary fallback={<AppErrorFallback />}>
      <RouterProvider router={router} />
    </Sentry.ErrorBoundary>
  </StrictMode>,
);
